import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component'

import 'react-lazy-load-image-component/src/effects/blur.css'

interface LazyImageProps {
  height: number
  width: number
}

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  blurOnLoad?: boolean
}

const LazyImageWrapper = styled.div<LazyImageProps>`
  .custom-lazy-class {
    display: block !important;
    position: relative;
    height: 0 !important;
    width: 100% !important;
    overflow: hidden;
    padding-bottom: ${({ height, width }) => `calc(${height} / ${width} * 100%)`};

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      max-width: inherit;
    }
  }
`

const AnimatedImg = animated.img

const Img = styled(AnimatedImg)`
  max-width: 100%;
  height: auto;
`

export const Image = ({ blurOnLoad = true, loading, alt, ...props }: ImageProps) => {
  const blurIn = useSpring({ opacity: 1, filter: 'blur(0)', from: { opacity: 0, filter: 'blur(15px)' } })
  const imgStyle = blurOnLoad ? blurIn : {}

  return <Img style={imgStyle} loading={'lazy' || loading} alt={alt} {...props} />
}

export const LazyImage = ({ effect, className, src, width, height, ...rest }: LazyLoadImageProps & LazyImageProps) => {
  return (
    <LazyImageWrapper className={className} width={width} height={height}>
      <LazyLoadImage
        {...rest}
        width={width}
        height={height}
        wrapperClassName="custom-lazy-class"
        effect={effect || 'blur'}
        src={src}
      />
    </LazyImageWrapper>
  )
}
